// cr 手機版按鈕 訂閱電子報
'use client'
import { setCRShowSubscribePop } from "@/slices/cryptoReadSlice";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { CR_BUSINESS_MAIL } from "./common/constant";

const CRButtonMobile = () =>{
    const [isShowBtn, setIsShowBtn] = useState(true);
    const dispatch = useDispatch();
    const btnRef = useRef();

    // 監聽滾動
    useEffect(()=>{
        let lastScrollTop = 0;
        let ticking = false;
        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    if (scrollTop > lastScrollTop) {
                        // console.log('向下滾動');
                        setIsShowBtn(false)
                        btnRef?.current?.classList.add('pointer-events-none')
                    } else {
                        // console.log('向上滾動');
                        setIsShowBtn(true)
                        btnRef?.current?.classList.remove('pointer-events-none')
                    }
                    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
                    ticking = false;
                });
                ticking = true;
            }
        });
    },[])

    return(
        <div className="w-full m-auto px-[16px] asm:hidden uxxs:hidden flex center-center" ref={btnRef}>

            <div className={`mo-button-wrap gap-x-[10px] bottom-[30px] z-[10]
                fixed hidden w-[90vw]
                usm:flex 
                ${isShowBtn? 'show-btn': 'remove-btn' }
            `}>
                <Button
                    text={'商業合作'}
                    color={'text-white bg-black border-black hover:text-white hover:bg-black7 hover:border-black7'}
                    func={()=>window.location.href=CR_BUSINESS_MAIL}
                />
                <Button
                    text={'免費訂閱電子報'}
                    color={'text-white bg-red0 border-red0 hover:text-white hover:bg-red1 hover:border-red1'}
                    func={()=>dispatch(setCRShowSubscribePop(true))}
                />
            </div>
            
        </div>
    )
}

export default CRButtonMobile;

const Button = ({text, color, func}) =>{
    return(
        <button
            className={`edm-btn-mo justify-center items-center
                w-auto px-[22px] py-[12px] h-[32px] box-content
                flex flex-grow
                trans text-btn1 rounded-[40px] border-1
                ${color}
            `}
            onClick={func}
        >
            {text}
        </button>
    )
}